import type { EnumUnion } from '@dresscode-frontend/utility-types';
import type { PeopleListApiResponse } from './-query/type';

/**
 * People画面のWorkerTypeフィルター
 * @description APIのcategoryとのマッピング: BOARD_MEMBER → BOARD
 */
export const PeopleWorkerTypeFilter = {
  ALL: 'ALL',
  EMPLOYEE: 'EMPLOYEE',
  BOARD_MEMBER: 'BOARD_MEMBER',
  CONTRACTOR: 'CONTRACTOR',
  COLLABORATOR: 'COLLABORATOR'
} as const;
export type PeopleWorkerTypeFilter = EnumUnion<typeof PeopleWorkerTypeFilter>;

/**
 * ID のマッチタイプ（APIレスポンスから派生）
 * @description APIの /v2/id-management/v2/people のmatchType定義に準拠
 */
export type IdMatchType = PeopleListApiResponse['items'][number]['ids'][number]['matchType'];

/**
 * マッチタイプの定数値（UI側での参照用）
 */
export const IdMatchType = {
  PERSONAL_EMAIL: 'PERSONAL_EMAIL',
  PERSONAL_MAIN_EMAIL: 'PERSONAL_MAIN_EMAIL',
  PERSONAL_SUB_EMAIL: 'PERSONAL_SUB_EMAIL',
  PERSONAL_PHONE: 'PERSONAL_PHONE',
  PERSONAL_SNS_ID: 'PERSONAL_SNS_ID',
  WORKER_EMAIL: 'WORKER_EMAIL',
  WORKER_MAIN_EMAIL: 'WORKER_MAIN_EMAIL',
  WORKER_SUB_EMAIL: 'WORKER_SUB_EMAIL',
  WORKER_MAIN_PHONE: 'WORKER_MAIN_PHONE',
  WORKER_SUB_PHONE: 'WORKER_SUB_PHONE',
  EMPLOYEE_NUMBER: 'EMPLOYEE_NUMBER',
  EMPLOYEE_ID: 'EMPLOYEE_ID',
  EMPLOYEE_SUB_ID: 'EMPLOYEE_SUB_ID',
  MANUAL_ASSIGN: 'MANUAL_ASSIGN'
} as const satisfies Record<IdMatchType, IdMatchType>;

/**
 * マッチタイプのラベルマッピング（i18nキー）
 */
export const MATCH_TYPE_I18N_KEYS = {
  PERSONAL_EMAIL: 'matchType.personalEmail',
  PERSONAL_MAIN_EMAIL: 'matchType.personalMainEmail',
  PERSONAL_SUB_EMAIL: 'matchType.personalSubEmail',
  PERSONAL_PHONE: 'matchType.personalPhone',
  PERSONAL_SNS_ID: 'matchType.personalSnsId',
  WORKER_EMAIL: 'matchType.workerEmail',
  WORKER_MAIN_EMAIL: 'matchType.workerMainEmail',
  WORKER_SUB_EMAIL: 'matchType.workerSubEmail',
  WORKER_MAIN_PHONE: 'matchType.workerMainPhone',
  WORKER_SUB_PHONE: 'matchType.workerSubPhone',
  EMPLOYEE_NUMBER: 'matchType.employeeNumber',
  EMPLOYEE_ID: 'matchType.employeeId',
  EMPLOYEE_SUB_ID: 'matchType.employeeSubId',
  MANUAL_ASSIGN: 'matchType.manualAssign'
} as const satisfies Record<IdMatchType, string>;

/**
 * People一覧のID項目（UI表示用）
 */
export type PeopleIdItem = {
  /** proxyUserId */
  id: string;
  loginId: string;
  matchType: IdMatchType;
};

/**
 * People一覧のPerson項目（UI表示用）
 */
export type PeoplePersonItem = {
  id: string;
  name: string;
  email: string | null;
  avatarUrl: string | null;
};